import React, { useEffect, useState } from 'react';
import LoadingIndicator from '@svb/api-loading-component/dist/components/index';
import CookieConsent, {
  // Cookies,
  getCookieConsentValue,
  // , resetCookieConsentValue
} from 'react-cookie-consent';
import { SVBQm } from '@svb/quantummetric-react-component';

export default function CookieConsentPolicy(props) {
  const { datatestid, baseUrl } = props;
  const [enableQM, setEnableQM] = useState(false);
  const [loading, setLoading] = useState(true);
  const [qtmSource, setqtmSource] = useState('');
  // if user accepts cookie consent
  const onCookiePolicyAccept = () => {
    setLoading(true);
    setEnableQM(true);
    setTimeout(() => {
      setLoading(false);
    }, 5);
  };
  // if user rejects cookie consent
  const onCookiePolicyDecline = () => {
    setLoading(true);
    setEnableQM(false);
    setTimeout(() => {
      setLoading(false);
    }, 5);
  };
  const DeclineButtonIcon = () => (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z'
        fill='black'
      />
    </svg>
  );
  useEffect(() => {
    const consentVal = !datatestid
      ? getCookieConsentValue('FirstCitizensPortalCookieConsent')
      : datatestid;
    /* istanbul ignore next */
    if (consentVal === 'true') {
      setEnableQM(true);
    } else {
      setEnableQM(false);
    }

    // set quantum metrics source based on base url
    if (baseUrl === 'beta.developer.svb.com' || baseUrl === 'developer.svb.com') {
      setqtmSource('https://cdn.quantummetric.com/qscripts/quantum-svb.js');
    } else {
      setqtmSource('https://cdn.quantummetric.com/qscripts/quantum-svbpreprod.js');
    }

    setLoading(false);
  }, []);

  return loading ? (
    <LoadingIndicator />
  ) : enableQM ? (
    <SVBQm
      enabled={
        process.env.REACT_APP_QTM_ENABLE &&
        process.env.REACT_APP_QTM_ENABLE.toLowerCase() === 'false'
          ? false
          : true
      }
      qtmsrc={qtmSource}
    />
  ) : (
    <>
      <SVBQm enabled={false} qtmsrc={qtmSource} />
      <CookieConsent
        cookieName='FirstCitizensPortalCookieConsent'
        onAccept={() => onCookiePolicyAccept()}
        onDecline={() => onCookiePolicyDecline()}
        location='bottom'
        buttonText='OK'
        flipButtons
        disableStyles
        enableDeclineButton
        declineButtonText={<DeclineButtonIcon />}
        containerClasses='cookie-containerClass position-fixed text-white d-block d-sm-inline-flex gap-4 justify-content-between align-items-center w-100'
        buttonWrapperClasses='d-inline-flex justify-content-sm-between justify-content-left w-100 mt-2 mt-sm-0'
        contentClasses='w-100 text-wrapper'
        buttonClasses='cookie-buttonClass svb-button svb-button_secondary-default'
        declineButtonClasses='cookie-declineButtonClass border-0 bg-transparent ms-3 ms-sm-0'
        sameSite='strict'
        cookieSecurity={true}
      >
        {`By clicking "OK", you agree to the storing of cookies on your device for the purposes of analyzing the usage of this site.`}
      </CookieConsent>
    </>
  );
}
